<harp-header *ngIf="currentApp.hasHeader"></harp-header>
<harp-spinner></harp-spinner>
<!-- Page Header -->
<div
  class="harp-login-page"
  role="main"
  [class.harp-custom-bg]="currentApp.hasCustomBg"
>
  <div class="harp-login-page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="text-center">
            <img
              class="harp-logo"
              src="{{ currentApp.adoLogo }}"
              alt="{{ currentApp.adoLogoAlt }}"
            />
            <p class="harp-page-subtitle">{{ currentApp.adoName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="harp-login-page-content">
    <div class="container">
      <!-- Default -->
      <div *ngIf="!isCodeSent && !isSetupStarted && !isRemoveDevice">
        <div class="col-md-8 offset-md-2">
          <div class="card harp-login-card harp-material">
            <div class="card-body">
              <app-alert [alertService]="alertService"></app-alert>

              <h1 class="harp-card-title">Set Up Two-Factor Authentication</h1>
              <p>
                You are required to set up two-factor authentication. Enter the
                fields below to add one or more two-factor authentication
                devices to your account.
                <a [routerLink]="['/help']" queryParamsHandling="merge"
                  >Learn More
                  <strong class="icon ion-md-arrow-round-forward"></strong
                ></a>
              </p>
              <p>
                All fields marked with an asterisk (<span class="required"
                  >*</span
                >) are required.
              </p>

              <div
                *ngIf="isAddingMfa && devices?.length"
                class="mt-4"
                role="table"
              >
                <app-mfa-device-table
                  [devices]="devices"
                  (removeDevice)="validateRemoveDevice($event)"
                ></app-mfa-device-table>
              </div>

              <form class="mt-4">
                <div class="row">
                  <div class="col-12">
                    <h2 class="harp-card-title">Add Device</h2>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <form [formGroup]="deviceTypeForm">
                      <harp-input
                        [inputConfig]="deviceTypeInputConfig"
                      ></harp-input>
                    </form>
                  </div>
                </div>

                <!-- SMS Setup -->
                <div *ngIf="deviceType === 'sms'">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        Please enter your phone number to receive a text with a
                        security code.
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <form
                        id="phone-number-input-form"
                        [formGroup]="phoneNumberForm"
                        #phoneForm="ngForm"
                      >
                        <harp-input [inputConfig]="phoneNumberInputConfig">
                          <button
                            [disabled]="phoneNumberForm.invalid"
                            (click)="onClickSendCode()"
                            class="btn btn-primary mb-3"
                            [id]="'phone-number-send-code-button-sms'"
                            type="submit"
                            appendGroup
                          >
                            Send Code
                          </button>
                        </harp-input>
                      </form>
                    </div>
                  </div>
                </div>

                <!-- Email Setup -->
                <div *ngIf="deviceType === 'email'">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        Security code will be sent to the email associated with
                        your profile for authentication.
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button
                        (click)="onEmailCode()"
                        type="button"
                        class="btn btn-primary"
                      >
                        Send Code
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Voice Setup -->
                <div *ngIf="deviceType === 'voice'">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        Please enter your phone number to receive a call with a
                        security code.
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <form
                        id="phone-number-input-form"
                        [formGroup]="phoneNumberForm"
                      >
                        <harp-input [inputConfig]="phoneNumberInputConfig">
                          <button
                            [disabled]="phoneNumberForm.invalid"
                            (click)="onClickSendCode()"
                            class="btn btn-primary mb-3"
                            [id]="'phone-number-send-code-button-voice'"
                            type="submit"
                            appendGroup
                          >
                            Send Code
                          </button>
                        </harp-input>
                      </form>
                    </div>
                  </div>
                </div>

                <!-- Google Authenticator Setup -->
                <div *ngIf="deviceType === 'google'">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        Please download the
                        <a
                          href="https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DAndroid&hl=en&oco=0"
                          target="_blank"
                          >Google Authenticator</a
                        >
                        app to your mobile device and click the button below to
                        initiate setup. The Google Authenticator app generates
                        two-factor authentication codes on your mobile device.
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button
                        (click)="createGoogleAuth()"
                        type="button"
                        class="btn btn-primary"
                      >
                        Configure Google Authenticator
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Okta Verify Setup -->
                <div *ngIf="deviceType === 'okta'">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        Please download the
                        <a
                          href="https://help.okta.com/en/prod/Content/Topics/Mobile/okta-verify-overview.htm"
                          target="_blank"
                          >Okta Verify</a
                        >
                        app to your mobile device and click the button below to
                        initiate setup. The Okta Verify app generates two-factor
                        authentication codes on your mobile device.
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button
                        (click)="createOktaVerify()"
                        type="button"
                        class="btn btn-primary"
                      >
                        Configure Okta Verify
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Okta Push Setup -->
                <div *ngIf="deviceType === 'push'">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        Please download the
                        <a
                          href="https://help.okta.com/en/prod/Content/Topics/Mobile/okta-verify-overview.htm"
                          target="_blank"
                          >Okta Verify Push</a
                        >
                        app to your mobile device and click the button below to
                        initiate setup. The Okta Verify Push app generates
                        two-factor authentication codes on your mobile device.
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button
                        (click)="createOktaVerifyPush()"
                        type="button"
                        class="btn btn-primary"
                      >
                        Configure Okta Verify Push
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  id="mfaFactorExists"
                  *ngIf="factorExists"
                  class="harp-validation-error mt-2"
                >
                  <p>{{ errorMessage }}</p>
                </div>

                <div *ngIf="showCompleteSetup" class="mt-3">
                  <button
                    class="btn btn-primary btn-lg"
                    [routerLink]="['/login/select-destination']"
                    queryParamsHandling="merge"
                  >
                    Complete Setup
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Enter Code -->
      <div *ngIf="isCodeSent && !isRemoveDevice">
        <div class="col-md-6 offset-md-3">
          <div class="card harp-login-card harp-material">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <app-alert [alertService]="alertService"></app-alert>

                  <!-- Resend Code Timer Alert -->
                  <div class="row">
                    <div class="col-md-12" [hidden]="!showResendCodeAlert">
                      <ngb-alert type="danger" [dismissible]="false">
                        A security code was recently sent. Please wait
                        {{ (resendCodeTimer$ | async) || 30 }} seconds before
                        trying again.
                      </ngb-alert>
                    </div>

                    <div
                      class="col-md-12"
                      [hidden]="!showResendCodeSuccessAlert"
                    >
                      <ngb-alert type="success" [dismissible]="false">
                        A security code was successfully sent. Please wait
                        {{ (resendCodeTimer$ | async) || 30 }} seconds before
                        trying again.
                      </ngb-alert>
                    </div>
                  </div>

                  <h1 class="harp-card-title">Enter Code</h1>
                  <p>Enter the security code to verify the device.</p>

                  <form [formGroup]="securityCodeForm">
                    <harp-input
                      [inputConfig]="securityCodeInputConfig"
                    ></harp-input>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    (click)="onClickActivate()"
                    class="btn btn-primary btn-lg harp-button-margin"
                    type="button"
                    [disabled]="!securityCodeForm.valid"
                  >
                    Submit
                  </button>
                  <button
                    (click)="onClickCancel()"
                    class="btn btn-link btn-lg harp-button-margin"
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p>
                    Need a new code?
                    <button
                      (click)="onClickReSend()"
                      [disabled]="
                        showResendCodeAlert || showResendCodeSuccessAlert
                      "
                      class="link"
                      type="button"
                    >
                      Resend Code
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Set up Google + Okta apps -->
      <div *ngIf="isSetupStarted && !isRemoveDevice">
        <div class="col-md-6 offset-md-3">
          <div class="card harp-login-card harp-material">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <h3 class="harp-card-title">
                    Configure Two-Factor Authentication App
                  </h3>

                  <!-- Configure Okta Verify Push -->
                  <ng-container *ngIf="deviceType === 'push'">
                    <div>
                      <p>
                        <strong>Step 1:</strong> Open the two-factor
                        authentication app on your mobile device and scan the QR
                        code or enter the key below to register your app and
                        receive a security code.
                      </p>
                    </div>

                    <div>
                      <p>
                        Open the two-factor authentication app on your mobile
                        device and scan the QR code.
                      </p>
                    </div>

                    <!-- QR Code -->
                    <p>
                      <img src="{{ qrImage }}" alt="QR Code" />
                    </p>

                    <div class="row">
                      <div class="col-12">
                        <button
                          (click)="onClickCancel()"
                          class="btn btn-link btn-lg harp-button-margin"
                          type="button"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Configure Google Authenticator -->
                  <ng-container *ngIf="deviceType !== 'push'">
                    <div>
                      <!-- QR Code -->
                      <p>
                        <img src="{{ qrImage }}" alt="QR Code" />
                      </p>

                      <p>OR</p>

                      <p>
                        Key: <strong>{{ sharedSecret }}</strong>
                      </p>

                      <hr />

                      <p>
                        <strong>Step 2:</strong> Enter the provided security
                        code below.
                      </p>

                      <div class="row">
                        <div class="col-12">
                          <p>
                            All fields marked with an asterisk (<span
                              class="required"
                              >*</span
                            >) are required.
                          </p>

                          <form [formGroup]="securityCodeForm">
                            <harp-input
                              [inputConfig]="securityCodeInputConfig"
                            ></harp-input>
                          </form>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <button
                            (click)="onClickActivate()"
                            class="btn btn-primary btn-lg harp-button-margin"
                            type="button"
                            [disabled]="!securityCodeForm.valid"
                          >
                            Submit
                          </button>
                          <button
                            (click)="onClickCancel()"
                            class="btn btn-link btn-lg harp-button-margin"
                            type="button"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Remove Device -->
      <div *ngIf="isRemoveDevice">
        <div class="col-md-6 offset-md-3">
          <div class="card harp-login-card harp-material">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <h1 class="harp-card-title">Remove Device</h1>
                  <p>
                    Removing device with contact:
                    {{ deviceToBeRemovedContact }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    type="button"
                    class="btn btn-lg btn-primary harp-button-margin"
                    (click)="removeDevice()"
                  >
                    Remove
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-link harp-button-margin"
                    (click)="cancelRemoveDevice()"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<harp-footer *ngIf="currentApp.hasFooter"></harp-footer>
